// removed by extract-text-webpack-plugin
module.exports = {"text":"styles__text___2kTEl","section":"styles__section___1VUdJ","bold":"styles__bold___3BMNk","italic":"styles__italic___2JQhM","label":"styles__label___9Bob1","tableData":"styles__tableData___8wuvc","link":"styles__link___1Ggi1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/categoryTabs/emotionsForm/answer/styles.css
// module id = 798
// module chunks = 0